import AboutCapitalAcres from "./components/AboutCapitalAcres";
import AboutDeveloper from "./components/AboutDeveloper";
import BestQuotes from "./components/BestQuotes";
import Details from "./components/Details";
import FloorPlan from "./components/FloorPlan";
import Footer from "./components/Footer";
import Form from "./components/Form";
import Header from "./components/Header";
import Hero from "./components/Hero";
import LocationBenefits2 from "./components/LocationBenefits2";
import NewForm from "./components/NewForm";
import Pricing from "./components/Pricing";
import Slider from "./components/Slider";

import StripSection from "./components/StripSection";

function App(){
  const project = "L&T Gateway Sewri"
  const galleryImages = [
    {
      src: "images/g1.png",
      alt: "gallery1",
      title: "gallery1",
    },
    {
      src: "images/g2.png",
      alt: "gallery2",
      title: "gallery2",
    },
    {
      src: "images/g3.png",
      alt: "gallery3",
      title: "gallery3",
    },
    {
      src: "images/g4.png",
      alt: "gallery4",
      title: "gallery4",
    },
    {
      src: "images/g5.png",
      alt: "gallery5",
      title: "gallery5",
    }
    // Add more amenities as needed
  ];
  const amenityImages = [
    {
      src: "images/a1.png",
      alt: "Amenity",
      title: "Amenity",
    },
    {
      src: "images/a2.png",
      alt: "Amenity",
      title: "Amenity",
    },
    {
      src: "images/a3.png",
      alt: "Amenity",
      title: "Amenity",
    },
    {
      src: "images/a4.png",
      alt: "Amenity",
      title: "Amenity",
    },
    {
      src: "images/a5.png",
      alt: "Amenity",
      title: "Amenity",
    }
    // Add more amenities as needed
  ];
  return(
    <>
    
    <div className="App">
      <Header  />
      <Hero />
      <NewForm />
      <StripSection/>
      <Details project={project} />
      <Pricing project={project} />
      <FloorPlan project={project} />
      <LocationBenefits2 project={project}/>
      <Slider project={project} title="Amenities" images={amenityImages} />
      <Slider project={project} title="Gallery" images={galleryImages} />
      <AboutDeveloper project={project} />
      <AboutCapitalAcres />
      <BestQuotes />
      <Footer />
      <Form />
    </div>
    </>
  )
}

export default App;
